<template>
  <div class="component-container" style="min-height: 350px;">

          <div v-if="isloading" class="loader-container">
                 <div class="loader"></div>
          </div>

        <div v-if="dataerror != null">
                        <div class="parent">
                            <div class="child">
                                    <p style="color:black;line-height:200px;font-size: 2em;text-align: center;">{{langConv("There are no events for this competition")}}</p>
                                   
                                    <p style="color:lightgray;line-height:100px;text-align: center;"><a class="qborderlink" href="/">Return to Home Page</a></p>
                               
                            </div>
                        </div>
                    </div> 


        <template v-else>
    <div class="grid-container">
      <!-- Main content wrapper -->
      <div class="grid-x grid-margin-x">
        <div class="cell small-12 medium-10 medium-offset-1">
          
          <template v-if="!isloading">
            <!-- unique by competition -->
            <div v-for="(row) in unique(eventsbycompetition.BO,'compdesc', 'ortpo', '1')" :key="row.bid">
              
              <!-- competition level promo -->
              <bannercompetitions :CompID="row.cnid" />

              <div class="grid-x">
                <div class="cell">
                  <h1 class="qmajorheader qalignleft">{{row.compdesc}}</h1>
                </div>
              </div>

              <!-- Events -->
              <div v-for="(row2, a) in eventsbycompetition.BO" :key="a">
                <template v-if="row2.compdesc == row.compdesc">
                  
                  <!-- Date header - first occurrence -->
                  <div v-if="a==0" class="grid-x qsmallfont qhighlight" style="line-height:1.5rem">
                    <div class="cell small-8 medium-6 qalignleft">
                      {{$todayTomorrow(row2.t,$dateformattype.daymonth) }} @ {{$todayTomorrow(row2.t,$dateformattype.timeonly)}}
                    </div>
                    <div class="cell small-1 text-center">{{ langConv(eventsbycompetition.h.head1) }}</div>
                    <div class="cell small-1 text-center">{{ langConv(eventsbycompetition.h.head2) }}</div>
                    <div class="cell small-1 text-center">{{ langConv(eventsbycompetition.h.head3) }}</div>
                    <div class="cell medium-2 show-for-medium"></div>
                  </div>

                  <!-- Date header - subsequent occurrences -->
                  <div v-else-if="eventsbycompetition.BO[a-1].t != row2.t" 
                       class="grid-x qsmallfont qhighlight" 
                       style="line-height:1.5rem; margin-top:2px">
                    <div class="cell small-8 medium-6 qalignleft">
                      {{$todayTomorrow(row2.t,$dateformattype.daymonth) }} @ {{$todayTomorrow(row2.t,$dateformattype.timeonly)}}
                    </div>
                    <div class="cell small-1 text-center">{{ langConv(eventsbycompetition.h.head1) }}</div>
                    <div class="cell small-1 text-center">{{ langConv(eventsbycompetition.h.head2) }}</div>
                    <div class="cell small-1 text-center">{{ langConv(eventsbycompetition.h.head3) }}</div>
                    <div class="cell medium-2 show-for-medium"></div>
                  </div>

                  <!-- Event row -->
                  <div class="grid-x text-center" style="line-height:2rem">
                    <!-- Event name -->
                    <div class="cell small-8 medium-6 text-left">
                      <router-link 
                        :to="'/Event/' + eventsbycompetition.h.sport.replace(/\s+/g, '-') + '/' + row2.country.replace(/\s+/g, '-') + '/' + row2.compdesc.replace(/\s+/g, '-') + '/' + row2.team1.replace(/\s+/g, '-') + '-v-' + row2.team2.replace(/\s+/g, '-') + '/' + row2.betdesc.replace(/\s+/g, '-')"
                        custom
                        v-slot="{ href, navigate }">
                        <a :href="href" @click="clickGo(row2.urldesc,row2.bid,navigate)">
                          <span class="qborderlink qsmallfontplus1">{{row2.team1}}    
                          <star :cmpid="row2.t1id" :cmpdesc="row2.team1"></star>
                          <span>&nbsp;v&nbsp;</span></span>
                          <span class="qborderlink qsmallfontplus1">{{row2.team2}}</span>
                          <star :cmpid="row2.t2id" :cmpdesc="row2.team2"></star>
                        </a>
                      </router-link>
                      
                      <span v-if="row2.stat">
                        <img class="qpointer" style="height:20px;width:20px"  
                             v-on:click="showstats(row2.bid)" 
                             :src="require('/public/assets/images/statistics.png')" 
                             alt="statistics" 
                             :title="langConv('Previous Results')"/>
                      </span>
                    </div>

                    <!-- Odds - mobile -->
                    <div class="cell small-1 show-for-small-only bestoddssmall">{{$formatOddsTS(row2.odd1)}}</div>
                    <div v-if="eventsbycompetition.h.head2!=''" class="cell small-1 show-for-small-only bestoddssmall">{{$formatOddsTS(row2.odd2)}}</div>
                    <div class="cell small-1 show-for-small-only bestoddssmall">{{$formatOddsTS(row2.odd3)}}</div>

                    <!-- Odds - desktop -->
                    <div class="cell medium-1 show-for-medium bestodds" style="border:2px solid white">{{$formatOddsTS(row2.odd1)}}</div>
                    <div v-if="eventsbycompetition.h.head2!=''" class="cell medium-1 show-for-medium bestodds" style="border:2px solid white">{{$formatOddsTS(row2.odd2)}}</div>
                    <div class="cell medium-1 show-for-medium bestodds" style="border:2px solid white">{{$formatOddsTS(row2.odd3)}}</div>

                    <!-- Action buttons -->
                    <div @click="clickGo(row2.urldesc,row2.bid)" class="cell shrink hide-for-small-only" style="padding-left:15px">
                      <actionbutton :id="row2.bid.toString()" :linkbutton="true" buttontext="More" 
                                   :routerlinkpath="'/Event/' + eventsbycompetition.h.sport.replace(/\s+/g, '-') + '/' + row2.country.replace(/\s+/g, '-') + '/' + row2.compdesc.replace(/\s+/g, '-') + '/' + row2.team1.replace(/\s+/g, '-') + '-v-' + row2.team2.replace(/\s+/g, '-') + '/' + row2.betdesc.replace(/\s+/g, '-')">
                      </actionbutton>
                    </div>
                    
                    <div @click="clickGo(row2.urldesc,row2.bid)" class="cell shrink show-for-small-only" style="padding-left:15px">
                      <actionbutton :id="row2.bid.toString()" :linkbutton="true" buttontext="" 
                                   :routerlinkpath="'/Event/' + eventsbycompetition.h.sport.replace(/\s+/g, '-') + '/' + row2.country.replace(/\s+/g, '-') + '/' + row2.compdesc.replace(/\s+/g, '-') + '/' + row2.team1.replace(/\s+/g, '-') + '-v-' + row2.team2.replace(/\s+/g, '-') + '/' + row2.betdesc.replace(/\s+/g, '-')">
                      </actionbutton>
                    </div>
                  </div>

                  <!-- Stats section -->
                  <div v-if="openstat == row2.bid">
                    <resultstable :eventid="row2.bid"></resultstable>
                  </div>

                </template>
              </div>
            </div>

            <!-- Outrights section -->
            <div v-for="row in unique(eventsbycompetition.BO,'compdesc', 'ortpo', '0')" :key="row.guid">
              <!-- ... outrights content ... -->
            </div>
          </template>

        </div>
      </div>
    </div>
        </template>
  </div>
</template>

<script>
 
   // adapted from https://codepen.io/frogmcw/pen/deqRwa after failing to get the foundation accordian and Vue to work nicely
    import axios from 'axios';
    import star from '/src/components/components/star.vue'
    import bannercompetitions from '/src/components/adverts/bannercompetitions.vue'
    import resultstable from '../components/components/results.vue';
    import { fetchData } from '/src/components/plugins/api.js'

    export default {

        name: "events",
      metaInfo() {
       
        const baseUrl = process.env.VUE_APP_WEBSITE || ''
         const path = (this.$route && this.$route.fullPath) ? this.$route.fullPath : '/' 
        return {
            title: this.langConv(this.compdesc) + " | Oddsgalore",
            meta: [{
        
                vmid: 'description',
                name: 'description',
                content: this.compdesc
            },
            {
                vmid: 'og:title',
                property: 'og:title',
                content: this.compdesc,
            },    
            ],
            link: [{
                vmid: 'canonical',
                rel: 'canonical',
                href: baseUrl + path
            }]
        }
    },
        data: function () {
            return {
                eventsbycompetition: [],
                isloading: true,
                lastdate: '',
                openstat: 0,
                resultsloaded: false,
                compdesc: '',
                dataerror: []
            };
        },

        async serverPrefetch() {

            const path = this.$route.fullPath;
            
            //chop URL into array
            const urlparts = String(path).split("/");



              var eventParamstoString = urlparts[2] + '_' + urlparts[3];

              const data =  await fetchData("FeatureTables.svc/EventsbyCompetition", {

                    params: {
                        noitems: 10,
                        eventParams: eventParamstoString
                    }
                }).catch(error => {
                   this.dataerror = error
                });
            

                this.eventsbycompetition = JSON.parse(data)[0];

                // console.log(this.eventsbycompetition);

                //have to change title here because dont know about competition in routre.beforePush event 
                this.compdesc = this.eventsbycompetition.BO[0].compdesc + ' Events';   
                this.isloading  = false;
        },


        components: {
            star,
            bannercompetitions,
            resultstable
        },

        props: {
            
           event: String,
        
        },



  beforeRouteEnter(to, from, next) {
    
    next(async vm => {
      if (!vm.$store.state.wasSSR) {
        vm.eventsbycompetitionTable()
      }
    })
  },





        methods: {

            clickGo: function(bettype,bid, navigate) {

               
               
                // this.$store.commit('setBid',bid);
                // this.$store.commit('setBetType',bettype);
                          this.$nextTick(() => {
                if (navigate != null) { navigate()}
                });
            },


            showstats(val) {
                
              //  this.resultsTable(val);
                if (this.openstat == val) {
                    this.openstat = 0;
                } else {
                    this.openstat = val;
                }

            },


            storelastdate: function(val) {
                this.lastdate = val;

            },

            //get data for odds table
            async eventsbycompetitionTable() {




                        const path = this.$route.fullPath;
            
            //chop URL into array
            const urlparts = String(path).split("/");



              var eventParamstoString = urlparts[2] + '_' + urlparts[3];


                   axios.get(process.env.VUE_APP_WEBAPI  + "FeatureTables.svc/EventsbyCompetition", {

                    params: {
                        noitems: 10,
                        eventparams: eventParamstoString
                    }

                }).then(response => {
                    
                    this.eventsbycompetition = JSON.parse(response.data)[0];

                

                    //have to change title here because dont know about competition in routre.beforePush event 
                    this.compdesc = this.eventsbycompetition.BO[0].compdesc + ' Events';   
                    this.isloading  = false;
                 
                 

                }).catch(error => {
                  this.isloading  = false;
                  this.dataerror = error
              
                });
            },

        }

    }
</script>





